/* DW SALE + PRE-ORDER (CRO, 2026-09-25, site-wide sale Oct 2 - Oct 6).
   Config comes from snippets/dw-sale-config.liquid (window.DWSale). Three jobs, nothing else:
   1. QUICK-ADD CARD PRICE. snippets/dw-sale-price.liquid prints the sale price on every card the
      server renders. When a shopper switches colour inside quick add, assets/dw-quick-add.js
      rebuilds the card's price line from /products/<handle>.js with the plain price. This watches
      that price line and re-applies the same sale arithmetic (round(price x % / 100) off, per unit)
      so the card never falls back to full price mid-sale. A colour with its own compare-at price
      (clearance) is left exactly as quick add drew it.
   2. QUICK-ADD PRE-ORDER. Sizes the Liquid flagged as pre-order (data-po-ids: continue selling, 0 or
      less for this market) get a dot. The first tap on one does NOT add: it shows
      "Pre-order · ships by <date>" and asks for a second tap. The second tap adds, with the
      "Pre-order" line-item property switched on for that size only.
   3. END OF SALE. If the page was cached or left open past the end time, html.dw-sale-over (set
      in the config snippet) hides every sale price and the crossed-out price reads as normal; a page
      still open at the end time flips at that moment (html.dw-sale-ended also hides the sale banners).
   rev 2 (2026-09-25, after critique):
   4. REBUY CARDS. Rebuy's product and cart widgets draw their own prices. While the sale runs, each
      Rebuy card gets the same sale price + crossed-out regular price (Rebuy's own price line is kept,
      hidden, and re-read whenever Rebuy redraws it, e.g. on a colour change). Cards with their own
      compare-at price (the Archive) are left as Rebuy draws them.
   5. PRE-ORDER, ANY ROUTE. A cart check runs after every cart write (Rebuy widget, cart +, quick add,
      bundle) and on page load. For each keep-selling size it reads the stock this page renders
      (/products/<handle>?view=dw-po) and makes sure the order line says what ships later:
      "Ships by Oct 24" when none is in stock, "2 of 3: ships by Oct 24" when the quantity is above
      stock. It only ever writes line properties (never quantities), at most 6 writes per page.
   6. QUANTITY ABOVE STOCK on the product page: "Only N ready to ship now..." under the button.
   rev 3 (2026-09-26, after critique round 2):
   7. CHECKOUT WAITS FOR THE PRE-ORDER CHECK. The check now starts as soon as a cart write finishes (no
      900 ms delay), and S.poBusy() tells the inline checkout hold in snippets/dw-sale-config.liquid
      (registered before the gift guard) whether a write or a check is still under way.
   8. US FREE-SHIPPING BAR. Rebuy's US bar counts to CA$100 converted ("$72.11 away"). While the sale runs,
      for USD shoppers, the shipping tier is set to the "US free-shipping line" setting (US$100) at
      Shopify's own rate, so the drawer reads "$100.00 away" when empty; put back after the sale.
   9. US CART FOOTER. Rebuy's "Ships same day before 1 PM EST (US & CA)" loses "(US & CA)" on the US store.
  10. REBUY SIZE LISTS. A keep-selling size at 0 or less reads "<colour> / <size> - Pre-order" in Rebuy's
      size list before ADD (looked up only once the widget is on screen; US: tees only).
   Revert: untick Theme settings > Sale pricing (DW) / Pre-order (DW); both off = file not loaded.
   To end the sale early, re-publish MAIN; unticking Sale pricing only removes the prices. */
(function () {
  'use strict';
  var S = window.DWSale;
  if (!S) return;
  var doc = document;

  function saleLive() {
    if (!S.on || doc.documentElement.classList.contains('dw-sale-over')) return false;
    var n = Date.now();
    if (S.start && n < S.start) return false;
    if (S.end && n >= S.end) { doc.documentElement.classList.add('dw-sale-over'); return false; }
    return true;
  }

  function has(list, value) {
    return (list || []).indexOf(String(value || '').toLowerCase().trim()) !== -1;
  }

  /* Same rules as snippets/dw-sale-price.liquid. Returns the sale price in cents, or 0 (= no sale price).
     rev 4 (2026-10-02): S.map comes from snippets/dw-sale-map.liquid ({"handle": "25", "handle|colour": "30",
     "handle": "=20.00" fixed}). With a map, Canada uses ONLY the map (colour rule first, then the handle rule);
     a product not in it (and not a tee) gets nothing. No map = the old full / discontinued-colour rules. */
  function saleCents(handle, color, cents) {
    if (!handle || !cents || has(S.exclude, handle)) return 0;
    var key = String(handle).toLowerCase().trim(), pct = 0, fixed = 0;
    if (has(S.teeHandles, key)) pct = (S.mkt === 'ca' || S.mkt === 'us') ? (S.tee[0] || 0) : 0;
    else if (S.mkt === 'ca') {
      var M = S.map || {}, own = Object.prototype.hasOwnProperty;
      if (Object.keys(M).length) {
        var ck = key + '|' + String(color || '').toLowerCase().replace(/\s+/g, '');
        var mv = (color && own.call(M, ck)) ? M[ck] : (own.call(M, key) ? M[key] : '');
        mv = String(mv || '');
        if (mv.charAt(0) === '=') fixed = Math.round(parseFloat(mv.slice(1)) * 100) || 0;
        else pct = parseFloat(mv) || 0;
      } else {
        pct = S.full || 0;
        if (has(S.discHandles, key) && has(S.discColors, color)) pct = S.disc || 0;
      }
    }
    if (pct > 0) return cents - offCents(cents, pct);
    if (fixed > 0 && fixed < cents) return fixed;
    return 0;
  }

  function offCents(cents, pct) { return Math.round(cents * pct / 100); }

  function themeSettings() { return (window.themeVariables && window.themeVariables.settings) || {}; }

  function amount(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
  }

  function money(cents) {
    var s = themeSettings();
    var format = (s.currencyCodeEnabled ? s.moneyWithCurrencyFormat : s.moneyFormat) || s.moneyFormat || '${{amount}}';
    return format.replace(/\{\{\s*\w+\s*\}\}/, amount(cents));
  }

  function cardHTML(cents, sale, tee, hidden) {
    var html = '<span class="price price--highlight dw-sp__now" data-dw-sp="js"><span class="visually-hidden">' +
      hidden.sale + '</span>' + money(sale) + '</span>' +
      '<span class="price price--compare dw-sp__was"><span class="visually-hidden">' + hidden.regular +
      '</span>$' + amount(cents) + '</span>';
    if (tee) {
      var two = (cents - offCents(cents, S.tee[1] || 0)) * 2;
      var three = (cents - offCents(cents, S.tee[2] || 0)) * 3;
      html += '<span class="dw-sp__tiers">2 for $' + amount(two) + ' &middot; 3 for $' + amount(three) + '</span>';
    }
    return html;
  }

  function parseCents(text) {
    var m = String(text || '').replace(/,/g, '').match(/(\d+(?:\.\d{1,2})?)/);
    return m ? Math.round(parseFloat(m[1]) * 100) : null;
  }

  /* ---- 1. quick-add card price ---- */
  function repriceCard(card) {
    if (!saleLive()) return;
    var qa = card.querySelector('dw-quick-add');
    var list = card.querySelector('.product-item-meta .price-list');
    if (!qa || !list) return;
    if (list.querySelector('.dw-sp__now') || list.querySelector('.price--compare')) return;
    var main = list.querySelector('.price');
    if (!main) return;
    var hiddenEl = main.querySelector('.visually-hidden');
    var hiddenText = hiddenEl ? hiddenEl.textContent : 'Sale price';
    var text = main.textContent.replace(hiddenText, '');
    if (/[A-Za-z]{4,}/.test(text.replace(/CAD|USD/g, ''))) return; /* "From ..." - leave it */
    var cents = parseCents(text);
    if (!cents) return;
    var handle = qa.getAttribute('data-handle');
    var colorEl = card.querySelector('.product-item-meta__color-name');
    var sale = saleCents(handle, colorEl ? colorEl.textContent : qa.getAttribute('data-color'), cents);
    if (!sale) return;
    var extra = list.querySelector('.price--block');
    list.innerHTML = cardHTML(cents, sale, has(S.teeHandles, handle), { sale: hiddenText, regular: 'Regular price' }) +
      (extra ? extra.outerHTML : '');
  }

  function watchCards(root) {
    if (!S.on) return;
    (root || doc).querySelectorAll('product-item').forEach(function (card) {
      if (card.__dwSale || !card.querySelector('dw-quick-add')) return;
      var list = card.querySelector('.product-item-meta .price-list');
      if (!list) return;
      card.__dwSale = true;
      new MutationObserver(function () { repriceCard(card); }).observe(list, { childList: true });
    });
  }

  /* ---- 2. quick-add pre-order ---- */
  function poWhen() { return S.poDate ? 'ships by ' + S.poDate : (S.poFb || 'ships in 2 weeks'); }
  function poLabel() { return 'Pre-order · ' + poWhen(); }
  function poValue() { var w = poWhen(); return w.charAt(0).toUpperCase() + w.slice(1); }

  function poIds(qa) {
    if (!qa.__dwPo) qa.__dwPo = (qa.getAttribute('data-po-ids') || '').split(',').filter(Boolean);
    return qa.__dwPo;
  }

  function markChips(qa) {
    var ids = poIds(qa);
    if (!ids.length) return;
    var any = false;
    qa.querySelectorAll('.dw-qa__size').forEach(function (chip) {
      var po = !chip.disabled && ids.indexOf(chip.getAttribute('data-id') || '') !== -1;
      if (po) any = true;
      if (chip.classList.contains('dw-qa__size--po') !== po) chip.classList.toggle('dw-qa__size--po', po);
      if (!po && chip.classList.contains('dw-qa__size--armed')) chip.classList.remove('dw-qa__size--armed');
      var sr = chip.querySelector('.dw-qa__po-sr');
      if (po && !sr) chip.insertAdjacentHTML('beforeend', '<span class="visually-hidden dw-qa__po-sr"> ' + poLabel() + '</span>');
      if (!po && sr) sr.parentNode.removeChild(sr);
    });
    var row = qa.querySelector('.dw-qa__sizes');
    var note = qa.querySelector('.dw-qa__po');
    if (any && row && !note) {
      note = doc.createElement('p');
      note.className = 'dw-qa__po';
      note.setAttribute('role', 'status');
      row.parentNode.insertBefore(note, row);
    }
    if (note) {
      if (!any) { note.parentNode.removeChild(note); return; }
      var want = '• ' + poLabel();
      if (!qa.querySelector('.dw-qa__size--armed') && note.textContent !== want) note.textContent = want;
    }
  }

  function watchQuickAdds(root) {
    if (!S.po) return;
    (root || doc).querySelectorAll('dw-quick-add[data-po-ids]').forEach(function (qa) {
      if (qa.__dwPoWatch) return;
      qa.__dwPoWatch = true;
      var busy = false;
      new MutationObserver(function () {
        if (busy) return;
        busy = true;
        try { markChips(qa); } finally { busy = false; }
      }).observe(qa, { childList: true, subtree: true });
      markChips(qa);
    });
  }

  doc.addEventListener('click', function (event) {
    var chip = event.target && event.target.closest ? event.target.closest('.dw-qa__size[data-id]') : null;
    if (!chip) return;
    var qa = chip.closest('dw-quick-add');
    if (!qa) return;
    var id = chip.getAttribute('data-id');
    var po = S.po && poIds(qa).indexOf(id) !== -1;
    var input = qa.querySelector('[data-po-optional]');
    if (po && !chip.classList.contains('dw-qa__size--armed')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      qa.querySelectorAll('.dw-qa__size--armed').forEach(function (c) { c.classList.remove('dw-qa__size--armed'); });
      chip.classList.add('dw-qa__size--armed');
      markChips(qa);
      var note = qa.querySelector('.dw-qa__po');
      var size = (chip.childNodes[0] && chip.childNodes[0].textContent || '').trim();
      if (note) note.textContent = size + ': ' + poLabel() + '. Tap ' + size + ' again to add.';
      return;
    }
    if (input) input.disabled = !po;
    if (po) setTimeout(function () { chip.classList.remove('dw-qa__size--armed'); markChips(qa); }, 0);
  }, true);

  /* ---- 4. Rebuy cards ---- */
  function rebuyBlock(block) {
    var priceEl = block.querySelector('.rebuy-product-price');
    if (!priceEl) return;
    var mine = block.querySelector('.dw-rb-price');
    function clear() {
      if (block.classList.contains('dw-rb-sale')) block.classList.remove('dw-rb-sale');
      if (mine) mine.parentNode.removeChild(mine);
    }
    if (!saleLive() || priceEl.querySelector('.compare-at, s, del')) return clear();
    var link = block.querySelector('a[href*="/products/"]');
    var m = link ? (link.getAttribute('href') || '').match(/\/products\/([^?#/]+)/) : null;
    var handle = m ? decodeURIComponent(m[1]).toLowerCase() : '';
    var color = '';
    var sel = block.querySelector('select.rebuy-select');
    if (sel && sel.selectedIndex >= 0 && sel.options[sel.selectedIndex]) color = sel.options[sel.selectedIndex].text.split(' / ')[0];
    if (!color) { var ci = block.querySelector('.rebuy-color-input:checked'); if (ci) color = ci.value; }
    if (!color) { var dc = block.querySelector('.dw-colour'); if (dc) color = dc.textContent; }
    var moneyEl = priceEl.querySelector('.rebuy-money') || priceEl;
    var text = '';
    Array.prototype.forEach.call(moneyEl.childNodes, function (n) {
      if (n.nodeType === 1 && n.classList.contains('sr-only')) return;
      text += n.textContent;
    });
    var cents = parseCents(text);
    var sale = cents ? saleCents(handle, color, cents) : 0;
    if (!sale) return clear();
    var html = '<span class="price price--highlight dw-sp__now"><span class="visually-hidden">Sale price</span>' +
      money(sale) + '</span> <span class="price price--compare dw-sp__was">' +
      '<span class="visually-hidden">Regular price</span>$' + amount(cents) + '</span>';
    if (!mine) {
      mine = doc.createElement('div');
      mine.className = 'dw-rb-price price-list';
      priceEl.parentNode.insertBefore(mine, priceEl.nextSibling);
    }
    if (mine.innerHTML !== html) mine.innerHTML = html;
    if (!block.classList.contains('dw-rb-sale')) block.classList.add('dw-rb-sale');
  }
  var rbPending = false;
  function rebuyAll() {
    rbPending = false;
    try { shipBar(); } catch (e) {}
    try { usFooter(); } catch (e) {}
    if (S.on) doc.querySelectorAll('.rebuy-product-block').forEach(rebuyBlock);
    try { poOptions(); } catch (e) {}
  }

  /* ---- 8. US free-shipping bar (Rebuy) ---- */
  var shipOrig = typeof WeakMap === 'function' ? new WeakMap() : null;
  function shipBar() {
    if (S.mkt !== 'us' || !(Number(S.usShip) > 0) || !shipOrig) return;
    var SC = window.Rebuy && window.Rebuy.SmartCart;
    var bar = SC && SC.progressBar;
    if (!bar || !bar.tiers || !bar.tiers.forEach) return;
    var cur = (window.Shopify && window.Shopify.currency) || {};
    var rate = Number(cur.rate) || 0;
    var live = saleLive() && String(cur.active || '').toUpperCase() === 'USD' && rate > 0;
    var changed = false;
    bar.tiers.forEach(function (t) {
      if (!t || t.type !== 'shipping') return;
      if (live) {
        if (!shipOrig.has(t)) shipOrig.set(t, t.minimum);
        var want = Number(S.usShip) / rate;
        if (Math.abs(Number(t.minimum) - want) > 1e-6) { t.minimum = want; changed = true; }
      } else if (shipOrig.has(t)) {
        t.minimum = shipOrig.get(t);
        shipOrig['delete'](t);
        changed = true;
      }
    });
    S.shipBarLive = live;
    if (changed) { try { if (SC.view && typeof SC.view.$forceUpdate === 'function') SC.view.$forceUpdate(); } catch (e) {} }
  }

  /* ---- 9. US cart footer ---- */
  function usFooter() {
    if (S.mkt !== 'us') return;
    var f = doc.getElementById('footer-guarantee');
    if (!f) return;
    var txt = f.textContent;
    if (/\(\s*US\s*&\s*CA\s*\)/.test(txt)) f.textContent = txt.replace(/\s*\(\s*US\s*&\s*CA\s*\)/, '').trim();
  }

  /* ---- 10. Rebuy size lists: pre-order sizes ---- */
  var poIO = (S.po && 'IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      en.target.__dwPoSeen = true;
      poIO.unobserve(en.target);
      poOptionsFor(en.target);
    });
  }) : null;
  function blockHandle(block) {
    var link = block.querySelector('a[href*="/products/"]');
    var m = link ? (link.getAttribute('href') || '').match(/\/products\/([^?#/]+)/) : null;
    return m ? decodeURIComponent(m[1]).toLowerCase() : '';
  }
  function poOptionsFor(block) {
    var sel = block.querySelector('select.rebuy-select');
    var handle = blockHandle(block);
    if (!sel || !handle || has(S.exclude, handle)) return;
    if (S.mkt === 'us' && !has(S.teeHandles, handle)) return; /* only the tees are sold on the US store */
    poStock(handle).then(function (vs) {
      Array.prototype.forEach.call(sel.options, function (o) {
        var po = Object.prototype.hasOwnProperty.call(vs, o.value) && Number(vs[o.value]) <= 0;
        var marked = / - Pre-order$/.test(o.text);
        if (po && !marked && !/ - OOS$/.test(o.text)) o.text = o.text + ' - Pre-order';
        else if (!po && marked) o.text = o.text.replace(/ - Pre-order$/, '');
      });
    });
  }
  function poOptions() {
    if (!S.po) return;
    doc.querySelectorAll('.rebuy-product-block').forEach(function (b) {
      if (!b.querySelector('select.rebuy-select')) return;
      if (b.__dwPoSeen || !poIO) return poOptionsFor(b);
      if (!b.__dwPoObs) { b.__dwPoObs = true; poIO.observe(b); }
    });
  }
  function rebuySoon() {
    if (rbPending) return;
    rbPending = true;
    (window.requestAnimationFrame || setTimeout)(rebuyAll);
  }
  function watchRebuy() {
    doc.querySelectorAll('[data-rebuy-id], .rebuy-cart, #rebuy-cart, .rebuy-widget').forEach(function (w) {
      if (w.__dwRb) return;
      w.__dwRb = true;
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var t = records[i].target;
          var el = t.nodeType === 1 ? t : t.parentNode;
          if (el && el.closest && el.closest('.dw-rb-price')) continue;
          return rebuySoon();
        }
      }).observe(w, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['value', 'class'] });
      w.addEventListener('change', rebuySoon, true);
    });
    rebuySoon();
  }

  /* ---- 5. pre-order on the order line, whatever added it ---- */
  var PO = { data: {}, writes: 0, cap: 6, busy: false, again: false, timer: null, self: 0, inflight: 0, queued: false };
  /* True while a cart write is on its way or a pre-order check is waiting / running (read by the checkout hold). */
  function poBusy() { return PO.inflight > 0 || PO.queued || PO.busy; }
  var WRITE_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  function shopRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function poStock(handle) {
    if (PO.data[handle]) return PO.data[handle];
    /* No Accept: application/json header here: with it Shopify answers with the product JSON, not the view. */
    PO.data[handle] = fetch(shopRoot() + 'products/' + encodeURIComponent(handle) + '?view=dw-po', { credentials: 'same-origin' })
      .then(function (r) {
        if (r.ok) return r.text();
        try { if (r.body && r.body.cancel) r.body.cancel(); } catch (e) {}
        return '{}';
      })
      .then(function (t) { try { return (JSON.parse(t) || {}).v || {}; } catch (e) { return {}; } })
      .catch(function () { return {}; });
    return PO.data[handle];
  }
  function poPlan(items, stock) {
    var left = {}, changes = [];
    items.forEach(function (it) {
      var vs = stock[it.handle] || {};
      var id = String(it.variant_id);
      if (!(id in vs)) return;
      if (!(id in left)) left[id] = Math.max(0, Number(vs[id]) || 0);
      var q = Number(it.quantity) || 0;
      var back = Math.max(0, q - left[id]);
      left[id] = Math.max(0, left[id] - q);
      var props = {};
      Object.keys(it.properties || {}).forEach(function (k) { if (it.properties[k] !== null && it.properties[k] !== undefined) props[k] = it.properties[k]; });
      var have = props['Pre-order'];
      var want = back <= 0 ? null : (back >= q ? poValue() : back + ' of ' + q + ': ' + poWhen());
      if (want === null) {
        /* Blank, not deleted: /cart/change.js ignores a properties object without the key (measured). */
        if (have && /^\d+ of \d+: /.test(have)) { props['Pre-order'] = ''; changes.push({ id: it.key, quantity: q, properties: props }); }
        return;
      }
      if (have === want) return;
      props['Pre-order'] = want;
      changes.push({ id: it.key, quantity: q, properties: props });
    });
    return changes;
  }
  function poWrite(change) {
    PO.self++;
    var req;
    try {
      req = fetch(shopRoot() + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(change)
      });
    } finally { PO.self--; }
    return req;
  }
  function poCheck() {
    if (!S.po) return;
    if (PO.busy) { PO.again = true; return; }
    if (PO.writes >= PO.cap) return;
    PO.busy = true;
    fetch(shopRoot() + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var handles = [];
        items.forEach(function (it) { if (it.handle && !it.gift_card && Number(it.price) > 0 && handles.indexOf(it.handle) === -1) handles.push(it.handle); });
        if (!handles.length) return 0;
        return Promise.all(handles.map(poStock)).then(function (list) {
          var stock = {};
          handles.forEach(function (h, i) { stock[h] = list[i]; });
          var changes = poPlan(items, stock);
          var done = 0;
          return changes.reduce(function (p, c) {
            return p.then(function () {
              if (PO.writes >= PO.cap) return;
              PO.writes++;
              return poWrite(c).then(function (r) { if (r && r.ok) done++; });
            });
          }, Promise.resolve()).then(function () { return done; });
        });
      })
      .then(function (done) {
        if (!done) return;
        try { doc.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
        try { if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchCart === 'function') window.Rebuy.Cart.fetchCart(); } catch (e) {}
      })
      .catch(function () {})
      .then(function () {
        PO.busy = false;
        if (PO.again) { PO.again = false; poSoon(); }
      });
  }
  function poSoon() {
    clearTimeout(PO.timer);
    PO.queued = true;
    PO.timer = setTimeout(function () { PO.queued = false; poCheck(); }, 0);
  }
  function watchCartWrites() {
    if (!S.po || window.__dwPoCartWatch) return;
    window.__dwPoCartWatch = true;
    try {
      var of = window.fetch;
      if (typeof of === 'function') {
        window.fetch = function (input) {
          var u = ''; try { u = String((input && input.url) || input); } catch (e) {}
          var track = PO.self === 0 && WRITE_RE.test(u.split('#')[0]);
          if (track) PO.inflight++;
          var p;
          try { p = of.apply(this, arguments); } catch (err) { if (track) PO.inflight = Math.max(0, PO.inflight - 1); throw err; }
          if (track) p.then(function () { PO.inflight = Math.max(0, PO.inflight - 1); poSoon(); }, function () { PO.inflight = Math.max(0, PO.inflight - 1); });
          return p;
        };
      }
      var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (m, u) { try { this.__dwPoUrl = String(u); } catch (e) {} return XO.apply(this, arguments); };
      XMLHttpRequest.prototype.send = function () {
        try {
          if (this.__dwPoUrl && WRITE_RE.test(this.__dwPoUrl)) {
            PO.inflight++;
            this.addEventListener('loadend', function () { PO.inflight = Math.max(0, PO.inflight - 1); poSoon(); });
          }
        } catch (e) {}
        return XS.apply(this, arguments);
      };
    } catch (e) {}
    setTimeout(poCheck, 1500);
  }
  S.poPlan = poPlan;
  S.poCheck = poCheck;
  S.poBusy = function () { return !!S.po && poBusy(); };
  S.poState = PO;

  /* ---- 6. product page: quantity above what is in stock ---- */
  function qtyNotes() {
    doc.querySelectorAll('.dw-po-qnote[data-dw-po-stock]').forEach(function (note) {
      var stock = parseInt(note.getAttribute('data-dw-po-stock'), 10) || 0;
      var scope = note.closest('.shopify-section') || note.closest('form') || doc;
      var input = scope.querySelector('input[name="quantity"]');
      var q = input ? (parseInt(input.value, 10) || 1) : 1;
      var text = q > stock ? 'Only ' + stock + ' ready to ship now. The other ' + (q - stock) + ': pre-order, ' + poWhen() + '.' : '';
      if (note.textContent !== text) note.textContent = text;
      if (note.hidden !== !text) note.hidden = !text;
    });
  }
  function qtySoon() { setTimeout(qtyNotes, 0); }
  doc.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') qtySoon(); }, true);
  doc.addEventListener('change', function (e) { if (e.target && e.target.name === 'quantity') qtySoon(); }, true);
  doc.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('.quantity-selector__button')) setTimeout(qtyNotes, 50); }, true);

  function endTimer() {
    var e = S.end || window.DWSaleEnd || 0;
    var wait = e - Date.now();
    if (!e || wait <= 0 || wait > 86400000) return;
    setTimeout(function () {
      doc.documentElement.classList.add('dw-sale-over');
      doc.documentElement.classList.add('dw-sale-ended');
      rebuySoon();
    }, wait + 500);
  }

  /* ---- boot + late cards (collection filters, load more, Rebuy rows) ---- */
  function boot(root) { watchCards(root); watchQuickAdds(root); watchRebuy(); if (S.po) qtyNotes(); }
  function start() {
    saleLive();
    endTimer();
    watchCartWrites();
    boot(doc);
    ['rebuy:cart.change', 'rebuy:cart.ready', 'rebuy:smartcart.ready'].forEach(function (n) { doc.addEventListener(n, rebuySoon); });
    if (S.mkt === 'us') {
      var tries = 0, iv = setInterval(function () {
        tries++;
        var SC = window.Rebuy && window.Rebuy.SmartCart;
        if (SC && SC.progressBar) { rebuySoon(); clearInterval(iv); } else if (tries >= 60) clearInterval(iv);
      }, 250);
    }
    var pending = false;
    new MutationObserver(function (records) {
      if (pending) return;
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) {
          pending = true;
          (window.requestAnimationFrame || setTimeout)(function () { pending = false; boot(doc); });
          return;
        }
      }
    }).observe(doc.body, { childList: true, subtree: true });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
})();